import { FC, SyntheticEvent } from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { useTheme } from 'styled-components';

import { ScCustomHeader, ScDatePickerItem } from './styled';

import 'react-datepicker/dist/react-datepicker.css';

export interface DatePickerItemProps {
  startDate: Date | null;
  endDate: Date | null;
  secondary?: boolean;
  onChange(
    date: [Date | null, Date | null],
    event: SyntheticEvent<any, Event> | undefined
  ): void;
  onClickOutside?: () => void;
}

export const DatePickerItem: FC<DatePickerItemProps> = ({
  startDate,
  endDate,
  secondary,
  onChange,
  onClickOutside,
}) => {
  const { images } = useTheme();

  const renderCustomHeader: ReactDatePickerProps['renderCustomHeader'] = ({
    date,
    decreaseMonth,
    increaseMonth,
  }) => {
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      year: 'numeric',
    }).format(date);

    return (
      <ScCustomHeader>
        <div className="arrow" onClick={decreaseMonth}>
          <images.arrowUpGrayIcon.component />
        </div>
        <span>{formattedDate}</span>
        <div className="arrow" onClick={increaseMonth}>
          <images.arrowUpGrayIcon.component />
        </div>
      </ScCustomHeader>
    );
  };

  return (
    <ScDatePickerItem secondary={secondary}>
      <div className="data-picker-wrapper">
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={onChange}
          renderCustomHeader={renderCustomHeader}
          formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 1)}
          onClickOutside={onClickOutside}
          inline
        />
      </div>
    </ScDatePickerItem>
  );
};
